import type { Map } from 'mapbox-gl';

import {
  MARKER_WITH_CHECKBOX_SIZES,
  MARKER_WITHOUT_CHECKBOX_SIZES,
  PRICE_MARKER_STYLES,
} from './models';

export function loadPriceMarkersPills(map: Map): void {
  const heightPx = 32;
  const borderPx = 1;

  Object.entries(PRICE_MARKER_STYLES).forEach(([state, colors]) => {
    if (
      state === 'selected' ||
      state === 'selected-inspected' ||
      state === 'included' ||
      state === 'included-inspected'
    ) {
      MARKER_WITH_CHECKBOX_SIZES.forEach((bucket) => {
        const svg = createPillSVG(
          bucket.width,
          heightPx,
          borderPx,
          colors.fill,
          colors.stroke
        );
        const img = new Image();
        img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
        img.onload = (): void => {
          const id = `price-pill-${state}-${bucket.name}`;
          if (!map.hasImage(id)) {
            map.addImage(id, img);
          }
        };
      });
    } else {
      MARKER_WITHOUT_CHECKBOX_SIZES.forEach((bucket) => {
        const svg = createPillSVG(
          bucket.width,
          heightPx,
          borderPx,
          colors.fill,
          colors.stroke
        );
        const img = new Image();
        img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
        img.onload = (): void => {
          const id = `price-pill-${state}-${bucket.name}`;
          if (!map.hasImage(id)) {
            map.addImage(id, img);
          }
        };
      });
    }
  });
}

function createPillSVG(
  width: number,
  height: number,
  border: number,
  fill: string,
  stroke: string
): string {
  return `
      <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
        <rect x="0" y="0" width="${width}" height="${height}" rx="${height / 2}" ry="${height / 2}"
              fill="${fill}" stroke="${stroke}" stroke-width="${border}" />
      </svg>
    `;
}
